import { FrontProjectPageService, ProjectPageDataOutput } from "../service/client/FrontProjectPageService";
import { useAsyncMemo } from "./useAsyncMemo";

export const useProjectPageVariables = (slug: string): ProjectPageDataOutput | undefined => {
  const service = new FrontProjectPageService(slug);
  const defaultData: ProjectPageDataOutput = {
    summary: {
      order_count: 0,
      support_amount: 0,
      support_amount_reserved: 0,
    },
    realtime_comment_interval: 15,
    monument_names: [],
  };
  return useAsyncMemo(async () => {
    const result = await service.getData();
    try {
      if (result.isSuccess()) {
        return result.value;
      } else {
        return defaultData;
      }
    } catch (error) {
      console.error(error);
      return defaultData;
    }
  }, [slug]);
};
